import { Modal } from '@ts/components/Modal';
import { Countdown } from '@ts/components/Countdown';

export const init = () => {
    setInteractiveElements();
    setHTMXListeners();
}

const setHTMXListeners = () => {
    document.body.addEventListener('htmx:afterSwap', (event) => {
        const container = event.detail?.target ?? event.target;
        if (!container) return;

        setInteractiveElements(container);
    });

    document.body.addEventListener('htmx:historyRestore', (event) => {
        const container = event.detail?.target ?? event.target;
        if (!container) return;

        setInteractiveElements(container);
    });
};

const setInteractiveElements = (root = document) => {
    setEarlyAccessUrlRequestTrigger(root);
    setCountdownTimer();
}

const setEarlyAccessUrlRequestTrigger = (root = document) => {
    const earlyAccessLinks = root.querySelectorAll('[data-early-access-url]');
    earlyAccessLinks.forEach(link => {
        const earlyAccessUrl = link.getAttribute('data-early-access-url');
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const target = link.getAttribute('target') || '_self';
            getEarlyAccessUrl(earlyAccessUrl, target);
        });
    });
}

const getEarlyAccessUrl = async (url, target) => {
    try {
        const response = await fetch(url, { method: 'GET' });

        if (!response.ok) {
            handleEarlyAccessUrlError('There was an issue fetching the early access URL. Please try again later.');
            return;
        }

        const data = await response.json();
        
        if (!data?.url || typeof data.url !== 'string') {
            handleEarlyAccessUrlError('The early access URL was missing.');
            return;
        }

        handleEarlyAccessUrlResponse(data.url, target);

    } catch (error) {
        handleEarlyAccessUrlError(error.message || 'There was an issue fetching the early access URL. Please try again later.');
    }
}

const handleEarlyAccessUrlResponse = (url, target) => {
        if (target === '_self') {
            window.location.href = url;
        } else {
            window.open(url, target, 'noopener,noreferrer');
        }
}

const handleEarlyAccessUrlError = (error) => {
        Modal.createAlertModal({
        title: 'Error',
        message: error,
        closeBtnLabel: 'Close'
    });
}

const setCountdownTimer = () => {
    Countdown.create('input[data-countdown-display]');
}